<template lang="pug">
#coach-bottom-button
  .layer.layer-green
  .layer.layer-yellow
  .layer.layer-blue

  .balloon
    | 2週間無料体験実施中!! まずはお気軽にお申込みください。
  .button-container
    button(type='button', @click='$emit("goToApplication")')
      | 無料体験レッスンに申し込む
    .note 無料体験レッスン後、いつでも解約できます。
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
#coach-bottom-button {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 0 32px;
  z-index: 100;
  transform: translate3d(0, 0, 0);
  color: $text-title-color;

  .layer {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .layer-green {
    background-color: #bfce00;
    clip-path: polygon(0px 0%, 100% 30%, 100% 100%, 0 100%);
    opacity: 0.89;
    backdrop-filter: blur(30.5px);
  }

  .layer-yellow {
    background-color: #ffca29;
    clip-path: polygon(0 42%, 100% 10%, 100% 100%, 0 100%);
    opacity: 0.89;
    backdrop-filter: blur(30.5px);
  }

  .layer-blue {
    background: linear-gradient(135deg, #1faab3 3.31%, #1f85b3 97.96%);
    clip-path: polygon(0 45%, 100% 20%, 100% 100%, 0 100%);
    opacity: 0.89;
    backdrop-filter: blur(30.5px);
  }

  .layer-gray {
    background-color: #808080;
    clip-path: polygon(0 100%, 100% 90%, 100% 100%, 0 100%);
  }

  .balloon {
    position: relative;
    display: inline-block;
    z-index: 2;
    padding: 6px 8px;
    font-size: 12px;
    font-weight: 600;
    color: $text-primary-color;
    margin-top: 54px;

    &::before {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 49%;
      border-top: 8px solid $color-notification;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
    }

    background-color: $color-notification;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  }

  .button-container {
    z-index: 1;
    padding-top: 4px;

    button {
      width: 327px;
      height: 50px;
      border: none;
      border-radius: 12px;
      color: $color-primary;
      font-weight: 600;
      font-size: 15px;
      background-color: #fff;
      margin-bottom: 8px;
    }
    .note {
      text-align: center;
      font-weight: 600;
      font-size: 12px;
      opacity: 0.6;
    }
  }
}
</style>
